<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon size="sm" name="cil-building" />Programas de cursos
              <div class="card-header-actions">
                <router-link
                  to="/programas-de-cursos/crear"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a
                    :href="href"
                    class="card-header-action btn btn-sm btn-success"
                    @click="navigate"
                  >
                    <CIcon size="sm" name="cil-plus" />
                  </a>
                </router-link>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen programas de cursos registrados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #course_id-filter>
                <v-select
                  label="name"
                  :options="optionsCourses"
                  :reduce="(course) => course.id"
                  id="course_id"
                  v-model="columnFilter.course_id"
                  @search="onSearchCourses"
                  @input="filterTable"
                >
                  <template slot="no-options">Buscar</template>
                </v-select>
              </template>
              <template #syllabus_id-filter>
                <v-select
                  label="description"
                  :options="optionsSyllabus"
                  :reduce="(syllabus) => syllabus.id"
                  id="syllabus_id"
                  v-model="columnFilter.syllabus_id"
                  @search="onSearchSyllabus"
                  @input="filterTable"
                >
                  <template slot="no-options">Buscar</template>
                </v-select>
              </template>
              <template #enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>
              <template #course_id="{ item }">
                <td>
                  {{ item.course ? item.course.name : "" }}
                </td>
              </template>
              <template #syllabus_id="{ item }">
                <td>
                  {{ item.syllabus ? item.syllabus.description : "" }}
                </td>
              </template>
              <template #enabled="{ item }">
                <td>
                  <CBadge color="success" v-if="item.enabled == true"
                    >Activo</CBadge
                  >
                  <CBadge color="danger" v-else>Inactivo</CBadge>
                </td>
              </template>

              <template #detail="{ item }">
                <td>
                  <b-button-group size="xs">
                    <b-button
                      :to="{ path: 'programas-de-cursos/editar/' + item.id }"
                      variant="warning"
                      title="Editar"
                    >
                      <CIcon size="sm" name="cil-pencil" />
                    </b-button>
                    <b-button
                      @click="modalDelete(item.id)"
                      variant="danger"
                      title="Eliminar"
                    >
                      <CIcon size="sm" name="cil-trash" />
                    </b-button>
                  </b-button-group>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
    <section v-if="modShowCourseSyllabus">
      <CourseSyllabusDeleteModal
        :course_syllabus_id="course_syllabus_id"
        :modShowCourseSyllabus="modShowCourseSyllabus"
        @CourseSyllabusDeleteModal="afterDeletePaymentMethod"
      ></CourseSyllabusDeleteModal>
    </section>
  </section>
</template>
<script>
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesSyllabus from "@/plugins/services/courses-syllabus";
import Courses from "@/plugins/services/courses";
import Syllabus from "@/plugins/services/syllabus";

// components
import CourseSyllabusDeleteModal from "@/entities/courses-syllabus/CourseSyllabusDeleteModal.vue";

export default {
  name: "CoursesSyllabusList",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    CourseSyllabusDeleteModal,
    TableRecords,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
        },
        {
          key: "course_id",
          label: "Curso",
        },
        {
          key: "syllabus_id",
          label: "Pensum",
        },
        {
          key: "position",
          label: "Posición",
          filter: false,
        },
        {
          key: "enabled",
          label: "Estado",
          filter: true,
          _style: "min-width:160px;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      optionsCourses: [],
      optionsSyllabus: [],
      columnFilter: { column: null, asc: false, enabled: true },
      enabledOptions: Constants.enabledOptions,
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      course_syllabus_id: 0,
      modShowCourseSyllabus: false,
    };
  },
  created() {
    this.getAll(this.columnFilter);
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("courses-syllabus", q);
      CoursesSyllabus.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = { column: null, asc: false, enabled: true };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    modalDelete(id) {
      this.modShowCourseSyllabus = true;
      this.course_syllabus_id = id;
    },
    afterDeletePaymentMethod(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.clean();
      }
      this.modShowCourseSyllabus = response.modalShow;
    },
    onSearchSyllabus(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getSyllabus(loading, search);
      }
    },
    getSyllabus(loading = null, search = null) {
      Syllabus.selectAll(search)
        .then((res) => {
          this.optionsSyllabus = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
          console.log(err);
        });
    },
    onSearchCourses(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getCourses(loading, search);
      }
    },
    getCourses(loading = null, search = null) {
      Courses.selectAll(search)
        .then((res) => {
          this.optionsCourses = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
          console.log(err);
        });
    },
  },
};
</script>
